import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=604dd27c&scoped=true"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=604dd27c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604dd27c",
  null
  
)

export default component.exports